var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { FormattedMessage } from "@irati/utils/lang";
import { H1 } from "@irati/ui/src/Typography";
import SignUpOptions from "./SignUpOptions";
var SignUpSettings = /** @class */ (function (_super) {
    __extends(SignUpSettings, _super);
    function SignUpSettings(props) {
        var _this = _super.call(this, props) || this;
        _this.updateOption = function (option) {
            if (_this.state.activeOption === option) {
                return false;
            }
            _this.setState({
                activeOption: option
            });
        };
        _this.state = {
            activeOption: get(props.userTenant, "settings.signUpOption", "none"),
            ssoButtonText: get(props.userTenant, "settings.ssoButtonText", "")
        };
        return _this;
    }
    SignUpSettings.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(H1, null,
                React.createElement(FormattedMessage, { id: "admin.containers.companySignUpSettings.heading" })),
            React.createElement(SignUpOptions, { onClick: this.updateOption, activeOption: this.state.activeOption, ssoButtonText: this.state.ssoButtonText, saveChanges: this.changeSignUpOption, userTenant: this.props.userTenant, handleSave: this.props.handleSave })));
    };
    return SignUpSettings;
}(Component));
export var SignUpSettingsUnconnected = SignUpSettings;
var mapDispatchToProps = function (dispatch) {
    return { dispatch: dispatch };
};
var mapStateToProps = function (state) {
    return {
        userTenant: state.auth.userTenant
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SignUpSettings);
